import React from 'react';

const userPrefsStore = React.createContext({ userPrefs: null, setUserPrefs: () => {} });

export default userPrefsStore;